import React from 'react';
import PropTypes from 'prop-types';

import AddControl from './add_control';
import Assignee from './assignee';
import ManagedInput from 'components/form/managed_input';
import RemoveControl from './remove_control';

import { connect } from 'react-redux';
import { addAssignee, changeAssigneeGroup, removeAssigneeGroup } from './store/workflow/actions';

const modes = [
  {
    label: 'All',
    value: 'and_condition'
  },
  {
    label: 'Any',
    value: 'or_condition'
  }
];

export class TaskWorkflowAssigneeGroup extends React.Component {
  static propTypes = {
    addAssignee: PropTypes.func.isRequired,
    assigneeGroup: PropTypes.shape({
      assignees: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired
      })).isRequired,
      index: PropTypes.number.isRequired,
      mode: PropTypes.oneOf(['and_condition', 'or_condition']).isRequired
    }).isRequired,
    assigneeLabel: PropTypes.string.isRequired,
    changeAssigneeGroup: PropTypes.func.isRequired,
    removeAssigneeGroup: PropTypes.func.isRequired,
    step: PropTypes.object.isRequired
  }

  get mode() {
    return modes.find(mode => mode.value === this.props.assigneeGroup.mode);
  }

  addAssignee = () => {
    this.props.addAssignee(this.props.step, this.props.assigneeGroup);
  }

  removeAssigneeGroup = () => {
    this.props.removeAssigneeGroup(this.props.step, this.props.assigneeGroup);
  }

  handleModeChange = (mode) => {
    this.props.changeAssigneeGroup(this.props.step, this.props.assigneeGroup, { mode });
  }

  render() {
    return (
      <div className="panel panel-default task-workflow-assignee-group">
        <div className="panel-heading">
          <div className="mode-header">
            {this.props.assigneeLabel} Group {this.props.assigneeGroup.index + 1}
            {this.renderMode()}
          </div>

          <RemoveControl onClick={this.removeAssigneeGroup} />
        </div>

        <div className="panel-body">
          {this.props.assigneeGroup.assignees.map(this.renderAssignee)}
          <AddControl label={`Add ${this.props.assigneeLabel}`} onClick={this.addAssignee} />
        </div>
      </div>
    );
  }

  renderMode() {
    return (
      <ManagedInput
        options={modes}
        type="radioGroup"
        value={this.props.assigneeGroup.mode}
        onValueChange={this.handleModeChange}
      />
    );
  }

  renderAssignee = (assignee) => {
    return (
      <Assignee
        assignee={assignee}
        assigneeGroup={this.props.assigneeGroup}
        key={assignee.key}
        step={this.props.step}
      />
    );
  }
}

const mapStateToProps = state => ({
  assigneeLabel: state.static.assigneeLabel
});

const mapDispatchToProps = {
  addAssignee,
  changeAssigneeGroup,
  removeAssigneeGroup
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskWorkflowAssigneeGroup);
